import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PointOfSale } from 'app/models/point-of-sale.models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PtoventaService {
  

  constructor(private http: HttpClient) { }

  getAll(): Observable<PointOfSale | any> {
    return this.http.get(environment.apiUrl + 'sales-point');
  }

  getAllWithReceiptBooks(): Observable<PointOfSale | any> {
    return this.http.get(environment.apiUrl + 'sales-point');
  }

  getById(id): Observable<PointOfSale | any> {
    return this.http.get(environment.apiUrl + 'sales-point/' + id);
  }

  guardar(ptoventa: PointOfSale): Observable<any> {
    return this.http.post(environment.apiUrl + 'sales-point', ptoventa);
  }

  actualizar(id: number, ptoventa: PointOfSale): Observable<any> {
    return this.http.patch(`${environment.apiUrl}sales-point/${id}`, ptoventa);
  }

  eliminar(ptoventa: PointOfSale): Observable<any> {
    return this.http.delete(`${environment.apiUrl}sales-point/${ptoventa.id}`);
  }

  getReceiptBooksBySalesPoint(salesPointId: number, isBox?: boolean): Observable<any> {
    return this.http.get(`${environment.apiUrl}receipt-book/sales-point/${salesPointId}?isBox=${isBox}`);
  }

}
